import { MEMBERSHIP_ACCESS_PORTAL_PATH, MEMBERSHIP_PORTAL_LINK_TEXT } from "@/lib/membershipAccessFlow";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

export function MembershipPortalHint({ className }: { className?: string }) {
  return (
    <p className={cn("text-center text-xs text-zinc-500", className)}>
      <Link
        to={MEMBERSHIP_ACCESS_PORTAL_PATH}
        className="text-zinc-400 underline underline-offset-2 hover:text-amber-200/90"
      >
        {MEMBERSHIP_PORTAL_LINK_TEXT}
      </Link>
    </p>
  );
}
